import { Modal } from "reactstrap";
import { shortcutsObj, shortcutType } from "./reactGridHelper";
import styles from './ShortcutModal.module.scss'
import MeritoButton from "../../../../components/common/MeritoButtons/MeritoButtons";
import { MdOutlineClear as CloseIcon } from 'react-icons/md'

type Props = {
    showShortcuts: shortcutType[],
    setIsOpen: (value: boolean) => void,
    isOpen: boolean
}

const ShortcutModal = ({ showShortcuts, isOpen, setIsOpen }: Props) => {

    const filteredShortcuts = showShortcuts.reduce((prev, curVal) => {
        const currentObj = shortcutsObj[curVal];
        prev.push(currentObj)
        return prev;
    }, [])

    return (
        <Modal
            isOpen={isOpen}
            toggle={() => {
                setIsOpen(!isOpen)
            }}
            size="md"
            contentClassName="shortcut_modal"
            centered={true}
        >
            <div className={styles.shortcutRootContainer}>
                <div className={styles.headerContainer}>
                    <div className={styles.leftContainer}>
                        <div className={styles.title}>
                            Spreadsheet Shortcuts
                        </div>
                    </div>
                    <div className={styles.rightContainer}>
                        <MeritoButton
                            type="secondary-1"
                            onClick={() => setIsOpen(!isOpen)}
                            icon={<CloseIcon />}
                            onlyIcon={true}
                        />
                    </div>
                </div>

                <div className={styles.tableRootContainer}>
                    <table className={styles.shortcutTable}>
                        <thead>
                            <tr>
                                <th>Action</th>
                                <th>Key Shortcut</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredShortcuts.map((shortcut, index) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <div className={styles.actionContainer}>
                                                {shortcut?.action}
                                            </div>
                                        </td>
                                        <td>
                                            <div className={styles.keyContainer}>
                                                {shortcut?.shortcut.map((item, index) => {
                                                    return <div className={styles.keyItem}>
                                                        {item}
                                                    </div>
                                                })}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </Modal>
    )
}

export default ShortcutModal;